import { render, staticRenderFns } from "./LoginSSOView.vue?vue&type=template&id=66e78ede&scoped=true&"
import script from "./LoginSSOView.vue?vue&type=script&lang=js&"
export * from "./LoginSSOView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e78ede",
  null
  
)

export default component.exports